
import { Button } from "@/components/ui/button";
import { Loader2, KeyRound } from "lucide-react";
import { GroupLeaderRequest } from "@/types/admin-requests";

interface ResetPasswordActionProps {
  request: GroupLeaderRequest;
  processingId: string | null;
  onResetPassword: (request: GroupLeaderRequest) => Promise<void>;
}

export const ResetPasswordAction = ({
  request,
  processingId,
  onResetPassword,
}: ResetPasswordActionProps) => {
  const isProcessing = !!processingId;
  const isCurrentProcessing = processingId === request.id;

  return (
    <Button
      variant="outline"
      onClick={() => onResetPassword(request)}
      disabled={isProcessing}
    >
      {isCurrentProcessing ? (
        <Loader2 className="h-4 w-4 animate-spin" />
      ) : (
        <KeyRound className="h-4 w-4 mr-2" />
      )}
      Återställ lösenord
    </Button>
  );
};
